// ----------------------------------------------------------------------

const account = {
  displayName: 'FINBACK USER',
  email: 'demo@finback670.com',
  photoURL: ''
};

export default account;
